import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { bps } from "@/lib/api";

export const TrafficChart = ({ data }) => (
  <div className="h-[240px] w-full" data-testid="traffic-chart">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="rxFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="hsl(190 95% 55%)" stopOpacity={0.55} />
            <stop offset="100%" stopColor="hsl(190 95% 55%)" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="txFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="hsl(268 85% 62%)" stopOpacity={0.55} />
            <stop offset="100%" stopColor="hsl(268 85% 62%)" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="2 6" className="stroke-border" vertical={false} />
        <XAxis dataKey="t" tick={{ fontSize: 10, fontFamily: "JetBrains Mono" }} stroke="currentColor" opacity={0.4} />
        <YAxis tickFormatter={bps} tick={{ fontSize: 10, fontFamily: "JetBrains Mono" }} stroke="currentColor" opacity={0.4} width={70} />
        <Tooltip
          formatter={(v, n) => [bps(v), n === "rx" ? "Download" : "Upload"]}
          contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 10, fontSize: 12 }}
        />
        <Area type="monotone" dataKey="rx" stroke="hsl(190 95% 55%)" strokeWidth={2} fill="url(#rxFill)" />
        <Area type="monotone" dataKey="tx" stroke="hsl(268 85% 62%)" strokeWidth={2} fill="url(#txFill)" />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);
